import { FC } from "react";
import TopicsPieChart from "../AuthAnalytics/AnalyticsPie";
import { ResearchTopic } from "../../context/AnalyticsContext";

interface AuthorData {
  authorName: string;
  totalCount: number;
  totalCitations: number;
  summaryStats: {
    h_index: number;
    i10_index: number;
  };
  researchTopics: ResearchTopic[];
}

interface AuthorDetailsModalProps {
  data: AuthorData;
  onClose: () => void;
}

const AuthorDetailsModal: FC<AuthorDetailsModalProps>  = ({ data, onClose}) => {

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg w-11/12 max-w-3xl h-5/6 p-6 shadow-lg relative overflow-y-auto">
        <button
          className="absolute top-3 right-4 text-2xl text-gray-400 hover:text-black font-bold"
          onClick={onClose}
          aria-label="Close Modal"
        >
          &times;
        </button>

        <h2 className="text-3xl font-bold text-[#1d244f] mb-6 border-b sm:mb-6 border-b pb-2 sm:pb-3">
          Profile
        </h2>

        <div className="space-y-8 text-gray-700 text-base sm:text-lg">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-2 sm:gap-y-4 mb-10">
          <p>
            <span className="font-semibold text-[#1d244f]">Name:</span>{" "}
            <span className="text-[#5BC0BE]">{data.authorName}</span>
          </p>
          <p>
            <span className="font-semibold text-[#1d244f]">Total Publications:</span>{" "}
            <span className="text-[#5BC0BE]">{data.totalCount}</span>
          </p>

          <p>
            <span className="font-semibold text-[#1d244f]">Total Citations:</span>{" "}
            <span className="text-[#5BC0BE]">{data.totalCitations}</span>
          </p>

          <p>
            <span className="font-semibold text-[#1d244f]">H-Index:</span>{" "}
            <span className="text-[#5BC0BE]">{data.summaryStats.h_index ?? "N/A"}</span>
          </p>

          <p>
            <span className="font-semibold text-[#1d244f]">i10-Index:</span>{" "}
            <span className="text-[#5BC0BE]">{data.summaryStats.i10_index ?? "N/A"}</span>
          </p>
          </div>

          <div className="w-full">
            <h3 className="text-2xl font-bold text-[#1d244f] mb-4 border-l-4 border-[#5BC0BE] pl-3">
              Research Topics
            </h3>
            <div className="w-full h-[320px] sm:h-[420px] mb-10">
              <TopicsPieChart topics={data.researchTopics} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthorDetailsModal;